<template>
  <QuoteForm
    :quote="quoteData"
    :supplier-product-data="supplierProductData"
    @update:quote="updateQuote"
    @update:supplier-product-data="handleMetadataUpdate"
    @saved="saveQuoteSnapshot"
  />
</template>

<script>
import { QuoteForm } from "@/modules/quotes";

export default {
  components: {
    QuoteForm,
  },
  computed: {
    quoteData() {
      return this.$store.getters["QuoteStore/active"];
    },
    supplierProductData() {
      return this.$store.getters["QuoteStore/supplierProductData"];
    },
  },
  methods: {
    updateQuote(val) {
      this.$store.commit("QuoteStore/SET_QUOTE", val);
    },
    handleMetadataUpdate(payload) {
      this.$store.commit("QuoteStore/SET_SUPPLIER_PRODUCT_DATA", payload);
    },
    saveQuoteSnapshot() {
      this.$store.commit("QuoteStore/SAVE_QUOTE_SNAPSHOT");
    },
  },
};
</script>
